/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AbortAssetUploadResponseContent,
  AttachTaskRequestContent,
  AttachTaskResponseContent,
  BadRequestErrorResponseContent,
  CatalogTaskRequestContent,
  CatalogTaskResponseContent,
  CompleteAssetUploadRequestContent,
  CompleteAssetUploadResponseContent,
  CompleteMilestoneResponseContent,
  CreateProjectResponseContent,
  DelegateGoogleClassroomAccessRequestContent,
  DelegateGoogleClassroomAccessResponseContent,
  DelegateRobloxSecretStoreAccessRequestContent,
  DelegateRobloxSecretStoreAccessResponseContent,
  GetAssetUploadPartUrlResponseContent,
  GetGoogleClassroomAccessStatusResponseContent,
  GetLinkedRobloxAccountResponseContent,
  GetRobloxSecretStoreAccessStatusResponseContent,
  GetSimulatedTaskResponseContent,
  GetTaskCatalogForProjectResponseContent,
  GetTaskCatalogResponseContent,
  GetTaskResponseContent,
  GradeTaskRequestContent,
  GradeTaskResponseContent,
  InternalFailureErrorResponseContent,
  LinkRobloxAccountRequestContent,
  LinkRobloxAccountResponseContent,
  ListAssetsResponseContent,
  ListProjectsResponseContent,
  ListTasksForPlayerResponseContent,
  MissingRequiredRobloxOAuthScopesResponseContent,
  NotAuthorizedErrorResponseContent,
  NotFoundErrorResponseContent,
  PlaceIdProvidedErrorResponseContent,
  ProjectAlreadyExistsErrorResponseContent,
  PutExperienceRequestContent,
  PutExperienceResponseContent,
  RobloxLinkRequiredErrorResponseContent,
  SecretAlreadyExistsErrorResponseContent,
  StartAssetUploadRequestContent,
  StartAssetUploadResponseContent,
  VendSecretResponseContent,
} from '../models';
import {
    AbortAssetUploadResponseContentFromJSON,
    AbortAssetUploadResponseContentToJSON,
    AttachTaskRequestContentFromJSON,
    AttachTaskRequestContentToJSON,
    AttachTaskResponseContentFromJSON,
    AttachTaskResponseContentToJSON,
    BadRequestErrorResponseContentFromJSON,
    BadRequestErrorResponseContentToJSON,
    CatalogTaskRequestContentFromJSON,
    CatalogTaskRequestContentToJSON,
    CatalogTaskResponseContentFromJSON,
    CatalogTaskResponseContentToJSON,
    CompleteAssetUploadRequestContentFromJSON,
    CompleteAssetUploadRequestContentToJSON,
    CompleteAssetUploadResponseContentFromJSON,
    CompleteAssetUploadResponseContentToJSON,
    CompleteMilestoneResponseContentFromJSON,
    CompleteMilestoneResponseContentToJSON,
    CreateProjectResponseContentFromJSON,
    CreateProjectResponseContentToJSON,
    DelegateGoogleClassroomAccessRequestContentFromJSON,
    DelegateGoogleClassroomAccessRequestContentToJSON,
    DelegateGoogleClassroomAccessResponseContentFromJSON,
    DelegateGoogleClassroomAccessResponseContentToJSON,
    DelegateRobloxSecretStoreAccessRequestContentFromJSON,
    DelegateRobloxSecretStoreAccessRequestContentToJSON,
    DelegateRobloxSecretStoreAccessResponseContentFromJSON,
    DelegateRobloxSecretStoreAccessResponseContentToJSON,
    GetAssetUploadPartUrlResponseContentFromJSON,
    GetAssetUploadPartUrlResponseContentToJSON,
    GetGoogleClassroomAccessStatusResponseContentFromJSON,
    GetGoogleClassroomAccessStatusResponseContentToJSON,
    GetLinkedRobloxAccountResponseContentFromJSON,
    GetLinkedRobloxAccountResponseContentToJSON,
    GetRobloxSecretStoreAccessStatusResponseContentFromJSON,
    GetRobloxSecretStoreAccessStatusResponseContentToJSON,
    GetSimulatedTaskResponseContentFromJSON,
    GetSimulatedTaskResponseContentToJSON,
    GetTaskCatalogForProjectResponseContentFromJSON,
    GetTaskCatalogForProjectResponseContentToJSON,
    GetTaskCatalogResponseContentFromJSON,
    GetTaskCatalogResponseContentToJSON,
    GetTaskResponseContentFromJSON,
    GetTaskResponseContentToJSON,
    GradeTaskRequestContentFromJSON,
    GradeTaskRequestContentToJSON,
    GradeTaskResponseContentFromJSON,
    GradeTaskResponseContentToJSON,
    InternalFailureErrorResponseContentFromJSON,
    InternalFailureErrorResponseContentToJSON,
    LinkRobloxAccountRequestContentFromJSON,
    LinkRobloxAccountRequestContentToJSON,
    LinkRobloxAccountResponseContentFromJSON,
    LinkRobloxAccountResponseContentToJSON,
    ListAssetsResponseContentFromJSON,
    ListAssetsResponseContentToJSON,
    ListProjectsResponseContentFromJSON,
    ListProjectsResponseContentToJSON,
    ListTasksForPlayerResponseContentFromJSON,
    ListTasksForPlayerResponseContentToJSON,
    MissingRequiredRobloxOAuthScopesResponseContentFromJSON,
    MissingRequiredRobloxOAuthScopesResponseContentToJSON,
    NotAuthorizedErrorResponseContentFromJSON,
    NotAuthorizedErrorResponseContentToJSON,
    NotFoundErrorResponseContentFromJSON,
    NotFoundErrorResponseContentToJSON,
    PlaceIdProvidedErrorResponseContentFromJSON,
    PlaceIdProvidedErrorResponseContentToJSON,
    ProjectAlreadyExistsErrorResponseContentFromJSON,
    ProjectAlreadyExistsErrorResponseContentToJSON,
    PutExperienceRequestContentFromJSON,
    PutExperienceRequestContentToJSON,
    PutExperienceResponseContentFromJSON,
    PutExperienceResponseContentToJSON,
    RobloxLinkRequiredErrorResponseContentFromJSON,
    RobloxLinkRequiredErrorResponseContentToJSON,
    SecretAlreadyExistsErrorResponseContentFromJSON,
    SecretAlreadyExistsErrorResponseContentToJSON,
    StartAssetUploadRequestContentFromJSON,
    StartAssetUploadRequestContentToJSON,
    StartAssetUploadResponseContentFromJSON,
    StartAssetUploadResponseContentToJSON,
    VendSecretResponseContentFromJSON,
    VendSecretResponseContentToJSON,
} from '../models';

export interface AbortAssetUploadRequest {
    experienceId: string;
    uploadSessionId: string;
}

export interface AttachTaskRequest {
    courseId: string;
    itemId: string;
    attachTaskRequestContent: AttachTaskRequestContent;
}

export interface CatalogTaskRequest {
    entryId: string;
    catalogTaskRequestContent: CatalogTaskRequestContent;
}

export interface CompleteAssetUploadRequest {
    experienceId: string;
    uploadSessionId: string;
    completeAssetUploadRequestContent: CompleteAssetUploadRequestContent;
}

export interface CompleteMilestoneRequest {
    robloxUserId: string;
    taskId: string;
    milestoneId: string;
}

export interface CreateProjectRequest {
    experienceId: string;
}

export interface DelegateGoogleClassroomAccessRequest {
    delegateGoogleClassroomAccessRequestContent: DelegateGoogleClassroomAccessRequestContent;
}

export interface DelegateRobloxSecretStoreAccessRequest {
    delegateRobloxSecretStoreAccessRequestContent: DelegateRobloxSecretStoreAccessRequestContent;
}

export interface GetAssetUploadPartUrlRequest {
    experienceId: string;
    uploadSessionId: string;
    partNumber: number;
}



export interface GetRobloxSecretStoreAccessStatusRequest {
    experienceId: string;
}

export interface GetSimulatedTaskRequest {
    experienceId: string;
    entryId: string;
}

export interface GetTaskRequest {
    taskId: string;
}


export interface GetTaskCatalogForProjectRequest {
    experienceId: string;
}

export interface GradeTaskRequest {
    robloxUserId: string;
    taskId: string;
    gradeTaskRequestContent: GradeTaskRequestContent;
}

export interface LinkRobloxAccountRequest {
    linkRobloxAccountRequestContent: LinkRobloxAccountRequestContent;
}

export interface ListAssetsRequest {
    experienceId: string;
}


export interface ListTasksForPlayerRequest {
    robloxUserId: string;
}

export interface PutExperienceRequest {
    putExperienceRequestContent: PutExperienceRequestContent;
}

export interface StartAssetUploadRequest {
    experienceId: string;
    startAssetUploadRequestContent: StartAssetUploadRequestContent;
}

export interface VendSecretRequest {
    experienceId: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Aborts an in-progress upload and cleans up partial objects.
     */
    async abortAssetUploadRaw(requestParameters: AbortAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AbortAssetUploadResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling abortAssetUpload.');
        }

        if (requestParameters.uploadSessionId === null || requestParameters.uploadSessionId === undefined) {
            throw new runtime.RequiredError('uploadSessionId','Required parameter requestParameters.uploadSessionId was null or undefined when calling abortAssetUpload.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/assets/uploads/{uploadSessionId}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))).replace(`{${"uploadSessionId"}}`, encodeURIComponent(String(requestParameters.uploadSessionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AbortAssetUploadResponseContentFromJSON(jsonValue));
    }

    /**
     * Aborts an in-progress upload and cleans up partial objects.
     */
    async abortAssetUpload(requestParameters: AbortAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AbortAssetUploadResponseContent> {
        const response = await this.abortAssetUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates the Google Classroom attachment associated with the
current iframe using one of the predefined CivicTech templates.
     */
    async attachTaskRaw(requestParameters: AttachTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AttachTaskResponseContent>> {
        if (requestParameters.courseId === null || requestParameters.courseId === undefined) {
            throw new runtime.RequiredError('courseId','Required parameter requestParameters.courseId was null or undefined when calling attachTask.');
        }

        if (requestParameters.itemId === null || requestParameters.itemId === undefined) {
            throw new runtime.RequiredError('itemId','Required parameter requestParameters.itemId was null or undefined when calling attachTask.');
        }

        if (requestParameters.attachTaskRequestContent === null || requestParameters.attachTaskRequestContent === undefined) {
            throw new runtime.RequiredError('attachTaskRequestContent','Required parameter requestParameters.attachTaskRequestContent was null or undefined when calling attachTask.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/classrooms/{courseId}/courseWork/{itemId}/attachments`.replace(`{${"courseId"}}`, encodeURIComponent(String(requestParameters.courseId))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters.itemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AttachTaskRequestContentToJSON(requestParameters.attachTaskRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AttachTaskResponseContentFromJSON(jsonValue));
    }

    /**
     * Creates or updates the Google Classroom attachment associated with the
current iframe using one of the predefined CivicTech templates.
     */
    async attachTask(requestParameters: AttachTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AttachTaskResponseContent> {
        const response = await this.attachTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a task catalog entry for the calling experience.
     */
    async catalogTaskRaw(requestParameters: CatalogTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogTaskResponseContent>> {
        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling catalogTask.');
        }

        if (requestParameters.catalogTaskRequestContent === null || requestParameters.catalogTaskRequestContent === undefined) {
            throw new runtime.RequiredError('catalogTaskRequestContent','Required parameter requestParameters.catalogTaskRequestContent was null or undefined when calling catalogTask.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/task-catalog/{entryId}`.replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CatalogTaskRequestContentToJSON(requestParameters.catalogTaskRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogTaskResponseContentFromJSON(jsonValue));
    }

    /**
     * Creates or updates a task catalog entry for the calling experience.
     */
    async catalogTask(requestParameters: CatalogTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogTaskResponseContent> {
        const response = await this.catalogTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finalizes an upload session and persists the asset metadata.
     */
    async completeAssetUploadRaw(requestParameters: CompleteAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteAssetUploadResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling completeAssetUpload.');
        }

        if (requestParameters.uploadSessionId === null || requestParameters.uploadSessionId === undefined) {
            throw new runtime.RequiredError('uploadSessionId','Required parameter requestParameters.uploadSessionId was null or undefined when calling completeAssetUpload.');
        }

        if (requestParameters.completeAssetUploadRequestContent === null || requestParameters.completeAssetUploadRequestContent === undefined) {
            throw new runtime.RequiredError('completeAssetUploadRequestContent','Required parameter requestParameters.completeAssetUploadRequestContent was null or undefined when calling completeAssetUpload.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/projects/{experienceId}/assets/uploads/{uploadSessionId}/complete`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))).replace(`{${"uploadSessionId"}}`, encodeURIComponent(String(requestParameters.uploadSessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteAssetUploadRequestContentToJSON(requestParameters.completeAssetUploadRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteAssetUploadResponseContentFromJSON(jsonValue));
    }

    /**
     * Finalizes an upload session and persists the asset metadata.
     */
    async completeAssetUpload(requestParameters: CompleteAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteAssetUploadResponseContent> {
        const response = await this.completeAssetUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async completeMilestoneRaw(requestParameters: CompleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteMilestoneResponseContent>> {
        if (requestParameters.robloxUserId === null || requestParameters.robloxUserId === undefined) {
            throw new runtime.RequiredError('robloxUserId','Required parameter requestParameters.robloxUserId was null or undefined when calling completeMilestone.');
        }

        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling completeMilestone.');
        }

        if (requestParameters.milestoneId === null || requestParameters.milestoneId === undefined) {
            throw new runtime.RequiredError('milestoneId','Required parameter requestParameters.milestoneId was null or undefined when calling completeMilestone.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/experiences/me/players/{robloxUserId}/tasks/{taskId}/milestones/{milestoneId}/completion`.replace(`{${"robloxUserId"}}`, encodeURIComponent(String(requestParameters.robloxUserId))).replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))).replace(`{${"milestoneId"}}`, encodeURIComponent(String(requestParameters.milestoneId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteMilestoneResponseContentFromJSON(jsonValue));
    }

    /**
     * 
     */
    async completeMilestone(requestParameters: CompleteMilestoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteMilestoneResponseContent> {
        const response = await this.completeMilestoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registers or updates the authenticated experience's profile metadata.
     */
    async createProjectRaw(requestParameters: CreateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateProjectResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling createProject.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateProjectResponseContentFromJSON(jsonValue));
    }

    /**
     * Registers or updates the authenticated experience's profile metadata.
     */
    async createProject(requestParameters: CreateProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateProjectResponseContent> {
        const response = await this.createProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * An endpoint which receives Google OAuth credentials (a code and code verifier)
from the frontend and uses them to call Google's token endpoint. The frontend
gets this code via a redirect back from Google after an OAuth flow in which
we request permissions to manage their classroom.
     */
    async delegateGoogleClassroomAccessRaw(requestParameters: DelegateGoogleClassroomAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DelegateGoogleClassroomAccessResponseContent>> {
        if (requestParameters.delegateGoogleClassroomAccessRequestContent === null || requestParameters.delegateGoogleClassroomAccessRequestContent === undefined) {
            throw new runtime.RequiredError('delegateGoogleClassroomAccessRequestContent','Required parameter requestParameters.delegateGoogleClassroomAccessRequestContent was null or undefined when calling delegateGoogleClassroomAccess.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/users/me/delegations/google-classroom`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DelegateGoogleClassroomAccessRequestContentToJSON(requestParameters.delegateGoogleClassroomAccessRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DelegateGoogleClassroomAccessResponseContentFromJSON(jsonValue));
    }

    /**
     * An endpoint which receives Google OAuth credentials (a code and code verifier)
from the frontend and uses them to call Google's token endpoint. The frontend
gets this code via a redirect back from Google after an OAuth flow in which
we request permissions to manage their classroom.
     */
    async delegateGoogleClassroomAccess(requestParameters: DelegateGoogleClassroomAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DelegateGoogleClassroomAccessResponseContent> {
        const response = await this.delegateGoogleClassroomAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * An endpoint which receives a Roblox API key from the frontend for
eventual use in creating and updating secrets for the provided
universe.
     */
    async delegateRobloxSecretStoreAccessRaw(requestParameters: DelegateRobloxSecretStoreAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DelegateRobloxSecretStoreAccessResponseContent>> {
        if (requestParameters.delegateRobloxSecretStoreAccessRequestContent === null || requestParameters.delegateRobloxSecretStoreAccessRequestContent === undefined) {
            throw new runtime.RequiredError('delegateRobloxSecretStoreAccessRequestContent','Required parameter requestParameters.delegateRobloxSecretStoreAccessRequestContent was null or undefined when calling delegateRobloxSecretStoreAccess.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/users/me/delegations/roblox-secret-store`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DelegateRobloxSecretStoreAccessRequestContentToJSON(requestParameters.delegateRobloxSecretStoreAccessRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DelegateRobloxSecretStoreAccessResponseContentFromJSON(jsonValue));
    }

    /**
     * An endpoint which receives a Roblox API key from the frontend for
eventual use in creating and updating secrets for the provided
universe.
     */
    async delegateRobloxSecretStoreAccess(requestParameters: DelegateRobloxSecretStoreAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DelegateRobloxSecretStoreAccessResponseContent> {
        const response = await this.delegateRobloxSecretStoreAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Issues a presigned URL for one multipart upload part.
     */
    async getAssetUploadPartUrlRaw(requestParameters: GetAssetUploadPartUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetUploadPartUrlResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling getAssetUploadPartUrl.');
        }

        if (requestParameters.uploadSessionId === null || requestParameters.uploadSessionId === undefined) {
            throw new runtime.RequiredError('uploadSessionId','Required parameter requestParameters.uploadSessionId was null or undefined when calling getAssetUploadPartUrl.');
        }

        if (requestParameters.partNumber === null || requestParameters.partNumber === undefined) {
            throw new runtime.RequiredError('partNumber','Required parameter requestParameters.partNumber was null or undefined when calling getAssetUploadPartUrl.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/assets/uploads/{uploadSessionId}/parts/{partNumber}`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))).replace(`{${"uploadSessionId"}}`, encodeURIComponent(String(requestParameters.uploadSessionId))).replace(`{${"partNumber"}}`, encodeURIComponent(String(requestParameters.partNumber))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetUploadPartUrlResponseContentFromJSON(jsonValue));
    }

    /**
     * Issues a presigned URL for one multipart upload part.
     */
    async getAssetUploadPartUrl(requestParameters: GetAssetUploadPartUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetUploadPartUrlResponseContent> {
        const response = await this.getAssetUploadPartUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Determines whether offline access to the calling user's Google Classroom
scopes has been granted. By offline access, I mean a refresh token exists.

This API is important since knowing If no refresh token exists, let's the
frontend guide them either through an auth flow that requests consent or
one that happens silently.
     */
    async getGoogleClassroomAccessStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGoogleClassroomAccessStatusResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/users/me/delegations/google-classroom/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGoogleClassroomAccessStatusResponseContentFromJSON(jsonValue));
    }

    /**
     * Determines whether offline access to the calling user's Google Classroom
scopes has been granted. By offline access, I mean a refresh token exists.

This API is important since knowing If no refresh token exists, let's the
frontend guide them either through an auth flow that requests consent or
one that happens silently.
     */
    async getGoogleClassroomAccessStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGoogleClassroomAccessStatusResponseContent> {
        const response = await this.getGoogleClassroomAccessStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getLinkedRobloxAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLinkedRobloxAccountResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/users/me/linked-identities/roblox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLinkedRobloxAccountResponseContentFromJSON(jsonValue));
    }

    /**
     * 
     */
    async getLinkedRobloxAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLinkedRobloxAccountResponseContent> {
        const response = await this.getLinkedRobloxAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Determines whether Roblox Secret Store access has been delegated for the
specified experience and calling user.
     */
    async getRobloxSecretStoreAccessStatusRaw(requestParameters: GetRobloxSecretStoreAccessStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRobloxSecretStoreAccessStatusResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling getRobloxSecretStoreAccessStatus.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/delegations/roblox-secret-store/status`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetRobloxSecretStoreAccessStatusResponseContentFromJSON(jsonValue));
    }

    /**
     * Determines whether Roblox Secret Store access has been delegated for the
specified experience and calling user.
     */
    async getRobloxSecretStoreAccessStatus(requestParameters: GetRobloxSecretStoreAccessStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRobloxSecretStoreAccessStatusResponseContent> {
        const response = await this.getRobloxSecretStoreAccessStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a simulated task view for a catalog entry in a given project.
     */
    async getSimulatedTaskRaw(requestParameters: GetSimulatedTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSimulatedTaskResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling getSimulatedTask.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling getSimulatedTask.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/task-catalog/{entryId}/simulated-task`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSimulatedTaskResponseContentFromJSON(jsonValue));
    }

    /**
     * Retrieves a simulated task view for a catalog entry in a given project.
     */
    async getSimulatedTask(requestParameters: GetSimulatedTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSimulatedTaskResponseContent> {
        const response = await this.getSimulatedTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a persisted task instance if the caller is authorized to view it.
     */
    async getTaskRaw(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTaskResponseContent>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getTask.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTaskResponseContentFromJSON(jsonValue));
    }

    /**
     * Retrieves a persisted task instance if the caller is authorized to view it.
     */
    async getTask(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTaskResponseContent> {
        const response = await this.getTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the catalog of tasks exposed to classroom teachers.
     */
    async getTaskCatalogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTaskCatalogResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/task-catalog`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTaskCatalogResponseContentFromJSON(jsonValue));
    }

    /**
     * Retrieves the catalog of tasks exposed to classroom teachers.
     */
    async getTaskCatalog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTaskCatalogResponseContent> {
        const response = await this.getTaskCatalogRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves task catalog entries for one project (experience) owned by the caller.
     */
    async getTaskCatalogForProjectRaw(requestParameters: GetTaskCatalogForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTaskCatalogForProjectResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling getTaskCatalogForProject.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/task-catalog`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTaskCatalogForProjectResponseContentFromJSON(jsonValue));
    }

    /**
     * Retrieves task catalog entries for one project (experience) owned by the caller.
     */
    async getTaskCatalogForProject(requestParameters: GetTaskCatalogForProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTaskCatalogForProjectResponseContent> {
        const response = await this.getTaskCatalogForProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async gradeTaskRaw(requestParameters: GradeTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GradeTaskResponseContent>> {
        if (requestParameters.robloxUserId === null || requestParameters.robloxUserId === undefined) {
            throw new runtime.RequiredError('robloxUserId','Required parameter requestParameters.robloxUserId was null or undefined when calling gradeTask.');
        }

        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling gradeTask.');
        }

        if (requestParameters.gradeTaskRequestContent === null || requestParameters.gradeTaskRequestContent === undefined) {
            throw new runtime.RequiredError('gradeTaskRequestContent','Required parameter requestParameters.gradeTaskRequestContent was null or undefined when calling gradeTask.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/experiences/me/players/{robloxUserId}/tasks/{taskId}/grade`.replace(`{${"robloxUserId"}}`, encodeURIComponent(String(requestParameters.robloxUserId))).replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GradeTaskRequestContentToJSON(requestParameters.gradeTaskRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GradeTaskResponseContentFromJSON(jsonValue));
    }

    /**
     * 
     */
    async gradeTask(requestParameters: GradeTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GradeTaskResponseContent> {
        const response = await this.gradeTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Associates a Roblox-hosted identity with the currently authenticated Google
Classroom user. The caller must already be signed in with Google (to satisfy
the API's Cognito authorizer) and must provide the Roblox-backed Cognito ID
token that was issued by the Roblox OIDC provider.
     */
    async linkRobloxAccountRaw(requestParameters: LinkRobloxAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkRobloxAccountResponseContent>> {
        if (requestParameters.linkRobloxAccountRequestContent === null || requestParameters.linkRobloxAccountRequestContent === undefined) {
            throw new runtime.RequiredError('linkRobloxAccountRequestContent','Required parameter requestParameters.linkRobloxAccountRequestContent was null or undefined when calling linkRobloxAccount.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/users/me/linked-identities/roblox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkRobloxAccountRequestContentToJSON(requestParameters.linkRobloxAccountRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkRobloxAccountResponseContentFromJSON(jsonValue));
    }

    /**
     * Associates a Roblox-hosted identity with the currently authenticated Google
Classroom user. The caller must already be signed in with Google (to satisfy
the API's Cognito authorizer) and must provide the Roblox-backed Cognito ID
token that was issued by the Roblox OIDC provider.
     */
    async linkRobloxAccount(requestParameters: LinkRobloxAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkRobloxAccountResponseContent> {
        const response = await this.linkRobloxAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists assets for the calling user within a specific project.
     */
    async listAssetsRaw(requestParameters: ListAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssetsResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling listAssets.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/assets`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssetsResponseContentFromJSON(jsonValue));
    }

    /**
     * Lists assets for the calling user within a specific project.
     */
    async listAssets(requestParameters: ListAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssetsResponseContent> {
        const response = await this.listAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all projects a user has access to view
     */
    async listProjectsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListProjectsResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListProjectsResponseContentFromJSON(jsonValue));
    }

    /**
     * Lists all projects a user has access to view
     */
    async listProjects(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListProjectsResponseContent> {
        const response = await this.listProjectsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lists the pending tasks for a specific Roblox player within the authenticated experience experience.
     */
    async listTasksForPlayerRaw(requestParameters: ListTasksForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTasksForPlayerResponseContent>> {
        if (requestParameters.robloxUserId === null || requestParameters.robloxUserId === undefined) {
            throw new runtime.RequiredError('robloxUserId','Required parameter requestParameters.robloxUserId was null or undefined when calling listTasksForPlayer.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/experiences/me/players/{robloxUserId}/tasks`.replace(`{${"robloxUserId"}}`, encodeURIComponent(String(requestParameters.robloxUserId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTasksForPlayerResponseContentFromJSON(jsonValue));
    }

    /**
     * Lists the pending tasks for a specific Roblox player within the authenticated experience experience.
     */
    async listTasksForPlayer(requestParameters: ListTasksForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTasksForPlayerResponseContent> {
        const response = await this.listTasksForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registers or updates the authenticated experience's profile metadata.
     */
    async putExperienceRaw(requestParameters: PutExperienceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutExperienceResponseContent>> {
        if (requestParameters.putExperienceRequestContent === null || requestParameters.putExperienceRequestContent === undefined) {
            throw new runtime.RequiredError('putExperienceRequestContent','Required parameter requestParameters.putExperienceRequestContent was null or undefined when calling putExperience.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/experiences/me`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutExperienceRequestContentToJSON(requestParameters.putExperienceRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutExperienceResponseContentFromJSON(jsonValue));
    }

    /**
     * Registers or updates the authenticated experience's profile metadata.
     */
    async putExperience(requestParameters: PutExperienceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutExperienceResponseContent> {
        const response = await this.putExperienceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Starts an upload session for an asset owned by a project.

The server chooses single-part or multipart upload strategy based on
metadata such as content type and size.
     */
    async startAssetUploadRaw(requestParameters: StartAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartAssetUploadResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling startAssetUpload.');
        }

        if (requestParameters.startAssetUploadRequestContent === null || requestParameters.startAssetUploadRequestContent === undefined) {
            throw new runtime.RequiredError('startAssetUploadRequestContent','Required parameter requestParameters.startAssetUploadRequestContent was null or undefined when calling startAssetUpload.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/projects/{experienceId}/assets/uploads`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartAssetUploadRequestContentToJSON(requestParameters.startAssetUploadRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartAssetUploadResponseContentFromJSON(jsonValue));
    }

    /**
     * Starts an upload session for an asset owned by a project.

The server chooses single-part or multipart upload strategy based on
metadata such as content type and size.
     */
    async startAssetUpload(requestParameters: StartAssetUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartAssetUploadResponseContent> {
        const response = await this.startAssetUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async vendSecretRaw(requestParameters: VendSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VendSecretResponseContent>> {
        if (requestParameters.experienceId === null || requestParameters.experienceId === undefined) {
            throw new runtime.RequiredError('experienceId','Required parameter requestParameters.experienceId was null or undefined when calling vendSecret.');
        }

        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/projects/{experienceId}/secret`.replace(`{${"experienceId"}}`, encodeURIComponent(String(requestParameters.experienceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VendSecretResponseContentFromJSON(jsonValue));
    }

    /**
     * 
     */
    async vendSecret(requestParameters: VendSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VendSecretResponseContent> {
        const response = await this.vendSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

